export const style = {
  wrapper: {
    padding: `20px 0 0 0`,
    background: `#f8f8f8`,
    borderBottom: `#f8f8f8 1px solid`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Sitemap/style/main.js